import { render, staticRenderFns } from "./FormularioModuloComponent.vue?vue&type=template&id=76c4e411"
import script from "./FormularioModuloComponent.vue?vue&type=script&lang=js"
export * from "./FormularioModuloComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports